import { useQuery } from 'data-fetching-client';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { getLongestValidI18nKey } from 'automation-ui-i18n/i18nUtils';
import EmailName from 'automation-ui-references/customer-data/EmailName';
import wireAssociationDefinitions from 'automation-ui-associations/hocs/wireAssociationDefinitions';
import SkeletonText from 'automation-ui-core/components/SkeletonText';
import { GET_OBJECT_TYPE_BY_ID } from 'automation-ui-references/object-type-properties/ObjectTypesQueries';
import * as CRMObjectTypes from 'automation-ui-references/object-types/CRMObjectTypes';
import getAssociationLabel from 'automation-ui-associations/utils/getAssociationLabel';
import findAssociationDefinitionFromSpec from 'automation-ui-associations/utils/findAssociationDefinitionFromSpec';
import { compose } from 'redux';
import get from 'immutable-less/transmute/get';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EmailActionDetail = ({
  actionMetadata: {
    contentId,
    recipients
  },
  messageLangPath = 'actionDetail',
  messageLangSuffix,
  options,
  associationDefinitionsQuery,
  disableEmailLink = false
}) => {
  const {
    // @ts-expect-error issue with undefined will come back to this
    data: {
      objectTypeById: targetObjectTypeDefinition
    } = {}
  } = useQuery(GET_OBJECT_TYPE_BY_ID, {
    variables: {
      objectTypeId: CRMObjectTypes.CONTACT_ID
    }
  });
  const emailName = /*#__PURE__*/_jsx(EmailName, {
    disabled: disableEmailLink,
    id: contentId
  });
  if (recipients.size) {
    const associationLabels = recipients.map(recipient => targetObjectTypeDefinition ? getAssociationLabel({
      associationDefinition: findAssociationDefinitionFromSpec(get('associationSpec', recipient), associationDefinitionsQuery),
      toObjectTypeDefinition: targetObjectTypeDefinition
    }) :
    /*#__PURE__*/
    /* eslint-disable-next-line react/jsx-key */
    _jsx(SkeletonText, {})).toJS();
    const _options = {
      associationLabels: /*#__PURE__*/_jsx("b", {
        children: associationLabels.map((label, index) => /*#__PURE__*/_jsxs("span", {
          children: [label, index < associationLabels.length - 1 ? ', ' : '']
        }, index))
      }),
      count: associationLabels.length,
      emailName
    };
    return messageLangPath === 'actionDetail' ? /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "automation-ui-action-features.action-features.email.action-details.content-ungated",
      options: _options
    }) : /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "automation-ui-action-features.action-features.email.action-preview.content-ungated",
      options: _options
    });
  }
  return messageLangPath === 'actionDetail' ? /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: "automation-ui-action-features.action-features.email.action-details.content",
    options: {
      emailName
    }
  }) : /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: getLongestValidI18nKey('automation-ui-action-features.action-features.email.action-preview.content', messageLangSuffix),
    options: {
      emailName,
      objectName: options && options.objectName
    }
  });
};
const ComposedEmailActionDetail = compose(WrappedComponent => props => /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, props, {
  fromObjectTypeIds: [props.flowObjectTypeId]
})), wireAssociationDefinitions)(EmailActionDetail);
export default ComposedEmailActionDetail;